import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { href: '/', label: '首页' },
  { href: '/category/rexue', label: '分类' },
  { href: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="px-4 md:px-6 max-w-[1400px] mx-auto flex items-center justify-between h-16" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 group cursor-pointer">
          <span className="text-xl font-heading font-bold text-primary-500 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
            洞洞杂货铺
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.href
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className="relative">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="text-sm bg-background-100 border border-background-200 rounded-full px-4 py-1.5 w-[180px] focus:w-[220px] focus:outline-none focus:border-primary-300 transition-all duration-300 text-foreground-700 placeholder:text-foreground-400"
            />
            <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          </div>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 space-y-3">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`block text-sm font-medium py-2 whitespace-nowrap ${
                location.pathname === link.href
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="relative pt-2">
            <input
              type="text"
              placeholder="搜索漫画..."
              className="text-sm bg-background-100 border border-background-200 rounded-full px-4 py-2 w-full focus:outline-none focus:border-primary-300 transition-colors text-foreground-700 placeholder:text-foreground-400"
            />
            <i className="ri-search-line absolute right-3 top-[60%] -translate-y-1/2 text-foreground-400 text-sm"></i>
          </div>
        </div>
      )}
    </header>
  );
}